module.exports = __webpack_public_path__ + "img/pic9.89eb77eb.png";